import { fetchMerchant, fetchProviders } from "../utils/api";
import { useState, useEffect } from "react";
import { TProvider } from "../utils/types";
export const useData = () => {
  const [merchants, setMerchants] = useState<TProvider[]>([]);
  const [providers, setProviders] = useState<TProvider[]>([]);

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const [providersRes, merchantsRes] = await Promise.all([
        fetchProviders(),
        fetchMerchant(),
      ]);
      setProviders(providersRes.data);
      setMerchants(merchantsRes.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Ошибка при загрузке!");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return { merchants, providers, loading, error };
};
